import React from 'react';
import ModuleHub from './components/ModuleHub';
import { getModuleById } from './config/accountingModules';

const GenericModulePage = ({ moduleId }) => {
  const module = getModuleById(moduleId);
  if (!module) return null;
  return <ModuleHub moduleId={moduleId} />;
};

export default GenericModulePage;
